import React, {
  useMemo,
  FC,
}                           from 'react';
import * as Yup             from 'yup';
import {
  Formik,
  FormikConfig,
}                           from 'formik';
import { Breakpoint }       from '@material-ui/core/styles/createBreakpoints';
import {
  IBannerAd,
  IBannerAdValues,
}                           from '@typings/nationalAdManagement';
import { EBackdropType }    from '@enums/nationalAdManagement';
import { BannerEditorForm } from './BannerEditorForm';

const validationSchema: Yup.Schema<IBannerAdValues> = Yup.object().shape({
  backdropType : Yup.number().required(),
  titleText    : Yup.string().max(40).required(),
  subtext      : Yup.string().max(60).required(),
  isActive     : Yup.boolean().required(),
  isClickable  : Yup.boolean().required(),
  buttonText   : Yup.string()
    .when('isClickable', {
      is        : true,
      then      : Yup.string().max(15).required(),
      otherwise : Yup.string().max(15),
    }),
  linkUrl: Yup.string()
    .when('isClickable', {
      is        : true,
      then      : Yup.string().max(255).required(),
      otherwise : Yup.string().max(255),
    }),
});

const getInitialValues = (banner: Partial<IBannerAd> | null): IBannerAdValues => ({
  id           : banner?.id,
  backdropType : banner?.backdropType ?? EBackdropType.Oceanside,
  titleText    : banner?.titleText ?? '',
  subtext      : banner?.subtext ?? '',
  linkUrl      : banner?.linkUrl ?? '',
  buttonText   : banner?.buttonText ?? '',
  isActive     : banner?.isActive ?? true,
  isClickable  : banner?.isClickable ?? true,
});

interface IProps extends Pick<FormikConfig<IBannerAdValues>, 'onSubmit'> {
  width      : Breakpoint;
  bannerData : IBannerAd | null;
  onCancel   : () => void;
}

export const BannerEditorWrapper: FC<IProps> = ({
  width,
  bannerData,
  onSubmit,
  onCancel,
}) => {
  const initialValues = useMemo<IBannerAdValues>(
    () => getInitialValues(bannerData),
    [bannerData],
  );

  return  (
    <Formik
      onSubmit         = {onSubmit}
      initialValues    = {initialValues}
      validationSchema = {validationSchema}
      validateOnBlur   = {false}
      enableReinitialize
    >
      <BannerEditorForm
        width    = {width}
        onCancel = {onCancel}
      />
    </Formik>
  );
};
